import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiSectionCardComponent } from './fi-section-card.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { InfoIconModule } from '@fi-shared/info-icon/info-icon.module';

@NgModule({
    declarations: [FiSectionCardComponent],
    imports: [CommonModule, MatIconModule, MatButtonModule, InfoIconModule],
    exports: [FiSectionCardComponent],
})
export class FiSectionCardModule {}
